import apiClient from '../utils/apiClient';

/** Team projects + assigned tasks. Facility-scoped like every other
 *  operational resource. Separate from the system `tasks` collection, which
 *  holds machine-generated chores (gate provisioning, lease follow-up). */
const base = (facilityId) => `/api/facilities/${facilityId}/projects`;

const projectsService = {
  list: (facilityId, status) =>
    apiClient.get(`${base(facilityId)}/`, { params: status ? { status } : undefined }),
  create: (facilityId, data) => apiClient.post(`${base(facilityId)}/`, data),
  update: (facilityId, id, data) => apiClient.put(`${base(facilityId)}/${id}`, data),
  remove: (facilityId, id) => apiClient.delete(`${base(facilityId)}/${id}`),

  listTasks: (facilityId, projectId, assigneeUserId) =>
    apiClient.get(`${base(facilityId)}/${projectId}/tasks`, {
      params: assigneeUserId ? { assignee_user_id: assigneeUserId } : undefined,
    }),
  createTask: (facilityId, projectId, data) =>
    apiClient.post(`${base(facilityId)}/${projectId}/tasks`, data),
  updateTask: (facilityId, projectId, taskId, data) =>
    apiClient.put(`${base(facilityId)}/${projectId}/tasks/${taskId}`, data),
  removeTask: (facilityId, projectId, taskId) =>
    apiClient.delete(`${base(facilityId)}/${projectId}/tasks/${taskId}`),

  /** Every task at the facility, across projects — the task lookup. */
  allTasks: (facilityId, params) =>
    apiClient.get(`${base(facilityId)}/all/tasks`, { params }),

  /** The facility ROSTER — the people who do the work. SMS-first, and not
   *  operator logins: a maintenance person gets texted a task and never signs
   *  into the software. Kept in `project_members`, never in `users`. */
  listMembers: (facilityId, includeInactive = false) =>
    apiClient.get(`${base(facilityId)}/members`, {
      params: { include_inactive: includeInactive },
    }),
  createMember: (facilityId, data) =>
    apiClient.post(`${base(facilityId)}/members`, data),
  updateMember: (facilityId, memberId, data) =>
    apiClient.put(`${base(facilityId)}/members/${memberId}`, data),
  deleteMember: (facilityId, memberId) =>
    apiClient.delete(`${base(facilityId)}/members/${memberId}`),

  /** Facility logins not yet on the roster. Operator users don't appear in
   *  project management by default; this makes importing one a click rather
   *  than retyping a colleague who is already in the system. */
  importableUsers: (facilityId) =>
    apiClient.get(`${base(facilityId)}/members/importable`),
  importUser: (facilityId, userId) =>
    apiClient.post(`${base(facilityId)}/members/import/${userId}`),

  /** Project membership — putting a roster person onto a board. */
  assignMember: (facilityId, projectId, memberId) =>
    apiClient.post(`${base(facilityId)}/${projectId}/members`, { member_id: memberId }),
  removeMember: (facilityId, projectId, memberId) =>
    apiClient.delete(`${base(facilityId)}/${projectId}/members/${memberId}`),

  myTasks: (facilityId, includeDone = false) =>
    apiClient.get(`${base(facilityId)}/my/tasks`, {
      params: { include_done: includeDone },
    }),
};

export default projectsService;
